module.exports = __webpack_public_path__ + "data/config.json";


//////////////////
// WEBPACK FOOTER
// ./app/services/api/config/config.json
// module id = KlZP
// module chunks = 1